export default class FormFieldComponent {
    el;
    alias;
    id;
    validators;
    validationContainerEl;

    constructor(el) {
        this.el = el;
        const { umbFieldId, umbFieldType } = this.el.dataset;
        this.id = umbFieldId;
        this.alias = umbFieldType;
        this.validators = [];
    }

    createValidationContainer() {
        const containerEl = document.createElement('ul');
        containerEl.classList.add('formulate__inline-validation-summary');
        this.validationContainerEl = containerEl;
        this.el.appendChild(this.validationContainerEl);
    }

    getFieldAlias() {
    }

    async validate() {
        const value = this.getValue();
        if (this.validators.length == 0) {
            this.hideValidationError();

            return Promise.resolve([{ valid: true }]);
        }

        const promises = [];

        this.validators.forEach((v) => {
            promises.push(v.validate(value));
        });

        // run promises in sequential order and return the first invalid response.
        for await (const promise of promises) {
            const result = await promise;

            if (result.valid === false) {
                this.showValidationError(result.messages);
                return Promise.resolve([result]);
            }
        }

        this.hideValidationError();

        return Promise.resolve([{ valid: true }]);
    };

    showValidationError(messages) {
        this.el.classList.add('formulate__field--validation-error');

        if (this.validationContainerEl) {
            this.clearValidationMessages();
        } else {
            this.createValidationContainer();
        }

        messages.forEach((message) => {
            const { text } = message;
            const messageEl = document.createElement('li');
            messageEl.innerText = text;
            messageEl.classList.add('formulate__inline-validation-summary__error');
            this.validationContainerEl.appendChild(messageEl);
        });
    }

    hideValidationError() {
        const errorElements = [
            this.el,
            ...this.el.querySelectorAll('.formulate__field--validation-error'),
        ];

        errorElements.forEach((element) => {
            element.classList.remove('formulate__field--validation-error');
        });

        this.clearValidationMessages();
    }

    clearValidationMessages() {
        const parent = this.validationContainerEl;

        if (parent) {
            while (parent.firstChild) {
                parent.removeChild(parent.firstChild);
            }
        }
    }
}